import React, { useState } from "react";
import moment from "moment";
import SimpleBar from "simplebar-react";
import { Icon, UserAvatar } from "../../../components/Component";
import { visitorName } from "./LivechatAside";
import { LivechatMediaGallery } from "./LivechatMedia";

const CHANNEL_LABELS = { livechat: "Live Chat", whatsapp: "WhatsApp", instagram: "Instagram" };
const PLATFORM_LABELS = { web: "Web", android: "Android", ios: "iOS" };

const ProfileGroup = ({ label, children }) => (
  <div className="chat-profile-group">
    <div className="chat-profile-head">
      <div>
        <span className="lead-text">{label}</span>
        <span className="sub-text">{children || "-"}</span>
      </div>
    </div>
  </div>
);

const LivechatContact = ({ conversation, contact, messages, tickets, options, profile }) => {
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const [isMediaOpen, setIsMediaOpen] = useState(true);
  const site = options.channels[conversation.channelId];
  const lastVisitorMessage = [...messages].reverse().find((message) => message.sender?.type === "user");
  const phones = contact?.phones?.map((phone) => `+${phone.phone}`).join(", ");
  const name = visitorName(conversation);

  return (
    <SimpleBar className={`nk-chat-profile ${profile.isOpen ? "visible" : ""}`}>
      <div className="user-card pt-5 sidebar-header">
        <div className="user-card px-4">
          <UserAvatar icon="user-alt-fill" />
          <div className="user-info">
            <span className="lead-text">{name}</span>
            {contact?.name && contact.name !== name && <span className="sub-text">({contact.name})</span>}
            {phones && <span className="sub-text">{phones}</span>}
          </div>
        </div>
        <button
          type="button"
          className="user-card-menu btn btn-icon btn-trigger text-primary chat-profile-toggle"
          aria-label="Tutup profil"
          onClick={profile.onToggle}
        >
          <Icon name="cross" />
        </button>
      </div>

      <div className="chat-profile" style={{ marginTop: 150 }}>
        <ProfileGroup label="Situs">{site?.name}</ProfileGroup>
        <ProfileGroup label="Platform">
          {PLATFORM_LABELS[lastVisitorMessage?.platform] ?? lastVisitorMessage?.platform}
        </ProfileGroup>
        <ProfileGroup label="Status">{conversation.authStatus === "logged_in" ? "Login" : "Tamu"}</ProfileGroup>
        <ProfileGroup label="Note">{contact?.notes}</ProfileGroup>

        <div className="chat-profile-group">
          <button
            type="button"
            className="chat-profile-head btn btn-block text-left"
            aria-expanded={isMediaOpen}
            onClick={() => setIsMediaOpen((open) => !open)}
          >
            <h6 className="title overline-title">Media</h6>
            <span className="indicator-icon">
              <Icon name={`chevron-${isMediaOpen ? "up" : "down"}`} />
            </span>
          </button>
          {isMediaOpen && (
            <div className="chat-profile-body">
              <div className="chat-profile-body-inner">
                <LivechatMediaGallery conversationId={conversation.conversationId} messages={messages} />
              </div>
            </div>
          )}
        </div>

        <div className="chat-profile-group">
          <button
            type="button"
            className="chat-profile-head btn btn-block text-left"
            aria-expanded={isHistoryOpen}
            onClick={() => setIsHistoryOpen((open) => !open)}
          >
            <h6 className="title overline-title">Riwayat tiket</h6>
            <span className="indicator-icon">
              <Icon name={`chevron-${isHistoryOpen ? "up" : "down"}`} />
            </span>
          </button>
          {isHistoryOpen && (
            <div className="chat-profile-body">
              <div className="chat-profile-body-inner">
                {tickets.length === 0 ? (
                  <span className="sub-text">Belum ada tiket</span>
                ) : (
                  <ul className="list-unstyled mb-0">
                    {tickets.map((ticket) => (
                      <li key={ticket.id} className="lc-ticket">
                        <div className="d-flex justify-content-between">
                          <span className="lead-text">{CHANNEL_LABELS[ticket.channel] ?? ticket.channel}</span>
                          <span className="badge badge-dim badge-gray rounded-pill">{ticket.status}</span>
                        </div>
                        <span className="sub-text">
                          {moment(ticket.createdAt).format("DD/MM/YYYY HH:mm")}
                          {ticket.user && `, ${ticket.user.firstName ?? ""} ${ticket.user.lastName ?? ""}`}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </SimpleBar>
  );
};

export default LivechatContact;
